import React from "react";
import { numDifferentiation, numDifferentiationWithoutSymbol } from "../../../CommonMethhods/CovertRupees";
import { checkEmpty } from "../../../CommonMethhods/CommonMethods";

function TotalPartner(props) {
  const statsData = props.statsData;


  return (
    <>
      <div className="card-box totalpartner-card bottom-25">
        <div className="row total-card-box">
          <div className="col-md-3 col-sm-6">
            <div className="total-topbox">
              <p className="value-title">
                <span className="circle-div"></span>
                <span>Total Partners</span>
              </p>
              <p className="totalpartner-value">{statsData?.total_partners || "0"}</p>
            </div>
            <div className="totalpartner-box partner-datacard">
              <span className="circle-div circle-green"></span>
              <div>
                <span className="totalpartner-box-value">{(statsData?.accounts_opened) || "0"}</span>
                <p className="totalpartner-box-title">Accounts Opened</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
          <div className="total-topbox">
              <p className="value-title">
                <span className="circle-div"></span>
                <span>Active Partners This Month</span>
              </p>
              <p className="totalpartner-value">{statsData?.active_this_month || "0"}</p>
            </div>
            <div className="totalpartner-box partner-datacard">
              <span className="circle-div circle-yellow"></span>
              <div>
                <span className="totalpartner-box-value">{statsData?.paid_accounts_opened || "0"}</span>
                <p className="totalpartner-box-title">Paid Accounts Opened</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
          <div className="total-topbox">
              <p className="value-title">
                <span className="circle-div"></span>
                <span>Inactive Partners</span>
              </p>
              <p className="totalpartner-value">{statsData?.inactive || 0}</p>
            </div>
            <div className="totalpartner-box partner-datacard">
              <span className="circle-div circle-purple"></span>
              <div>
                <span className="totalpartner-box-value">{statsData?.client_traded || 0}</span>
                <p className="totalpartner-box-title">Client Traded</p>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
          <div className="total-topbox">
              <p className="value-title">
                <span className="circle-div"></span>
                <span>MTF Book</span>
              </p>
              <p className="totalpartner-value">{statsData?.mtf_booked === undefined || null ? 0 
              : numDifferentiation(statsData?.mtf_booked)}</p>
            </div>
            <div className="totalpartner-box partner-datacard">
              <span className="circle-div circle-orange"></span>
              <div>
                <span className="totalpartner-box-value">{(statsData?.brokerage_generated) || 0}</span>
                <p className="totalpartner-box-title">Brokerage Generated</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TotalPartner;
